import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

const ResultsTableNotesCell = ({
  row,
  editingNotesRowId,
  editingNotesValue,
  setEditingNotesRowId,
  setEditingNotesValue,
  onCommitNotes,
}) => {
  const rowId = row?.original?.id;
  const value = row?.original?.uiNotes || '';
  const isEditing = Boolean(rowId) && rowId === editingNotesRowId;

  if (isEditing) {
    return (
      <TextField
        value={editingNotesValue}
        onChange={(event) => setEditingNotesValue(event.target.value)}
        onBlur={() => {
          const nextValue = editingNotesValue;
          setEditingNotesRowId(null);
          onCommitNotes?.(row, nextValue);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            event.currentTarget.blur();
          }
          if (event.key === 'Escape') {
            event.preventDefault();
            setEditingNotesRowId(null);
            setEditingNotesValue(value);
          }
        }}
        size="small"
        fullWidth
        multiline
        minRows={2}
        inputProps={{ 'data-testid': 'results-edit-notes' }}
      />
    );
  }

  return (
    <Box
      sx={{ width: '100%', cursor: 'text' }}
      onClick={(event) => {
        event.stopPropagation();
        if (!rowId) return;
        setEditingNotesRowId(rowId);
        setEditingNotesValue(value);
      }}
      data-testid={`results-notes-${rowId}`}
    >
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
        {value || '--'}
      </Typography>
    </Box>
  );
};

export default ResultsTableNotesCell;
